import React, { useState } from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import { listTransferSalesAction } from '_models/redux/list-transfer-sales/action';
import { cleanTransferSalesClean } from '_models/redux/list-transfer-sales/clean-action';
import DataTable from 'widgets/datagrid/DataTable';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { PageListSaleTransferHook } from './hooks/PageListSaleTransferHook';
import SearchForm from './components/SearchForm';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';

const PageListSaleTransfer = ({
  cleanTransferSalesClean,
  listTransferSalesAction,
  listTransferSales,
}) => {
  const {
    loading,
    columns,
    mappedRows,
    handleSearch,
    handleRowClick,
    handleButtonClick,
    pagination,
    page,
    size,
    handleSubmit,
    errors,
    register,
    errorMessage,
  } = PageListSaleTransferHook({
    cleanTransferSalesClean,
    listTransferSalesAction,
    listTransferSales,
  });

  // Estado para controlar si ya se realizó una búsqueda
  const [hasSearched, setHasSearched] = useState(false);

  // Nueva función para marcar que ya se buscó
  const handleSearchWithFlag = (...args) => {
    setHasSearched(true);
    return handleSearch(...args);
  };

  return (
    <>
      <Grid container justifyContent='left' marginBottom={4}>
        <Grid item size={{ xs: 10, sm: 8, md: 6, lg: 4 }}>
          <GenericAddButton
            onClick={handleButtonClick}
            buttonText='Nueva venta por transferencia'
            backgroundColor='#4C2484'
            size='small'
            icon={<AddCircleIcon />}
          />
        </Grid>
      </Grid>

      <Grid item size={{ xs: 12 }}>
        <SearchForm
          handleSubmit={handleSubmit}
          handleSearch={handleSearchWithFlag} // Usar la nueva función aquí
          errors={errors}
          register={register}
          errorMessage={errorMessage}
        />
      </Grid>
      <Grid item size={{ xs: 12 }}>
        {hasSearched ? (
          mappedRows?.length === 0 ? (
            <p>No hay registros disponibles.</p>
          ) : (
            <Box sx={{ height: '67vh' }}>
              <DataTable
                rows={mappedRows}
                columns={columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                loading={loading}
              />
            </Box>
          )
        ) : null}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  listTransferSales: state?.listTransferSales,
});

const mapDispatchToProps = {
  cleanTransferSalesClean,
  listTransferSalesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageListSaleTransfer);
